import {apiSlice} from './apiSlice';
import {DriverLicence, LinkRecordToProfileResponse, RecordAndProfileType} from '../../types/driverLicenceTypes';

export const driverLicenceInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDriverLicence: builder.query<DriverLicence | null, number | undefined>({
            query: (profileID?): string =>
                `/records/?type=driver_licence${profileID ? '&profile_id=' + profileID : ''}`,
            transformResponse: (response: DriverLicence[]) => {
                return response.length > 0 ? response[0] : null;
            },
            providesTags: ["DriverLicence"]
        }),
        updateDriverLicence: builder.mutation<DriverLicence | null, Partial<DriverLicence>>({
            query: (data) => ({
                url: `/records/${data.id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ["DriverLicence"],
        }),
        addDriverLicence: builder.mutation<{id: number}, DriverLicence>({
            query: (data) => ({
                url: '/records',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ["DriverLicence"],
        }),
        linkRecordToProfile: builder.mutation<LinkRecordToProfileResponse, RecordAndProfileType>({
            query: ({record_id, profile_id}) => ({
                url: `/records/link`,
                method: "POST",
                body: {record_id, profile_id},
            }),
            invalidatesTags: ["DriverLicence"],
        }),
    }),
});

export const driverLicenceEndpoints = driverLicenceInjectedEndpoints.endpoints;
export const {
    useGetDriverLicenceQuery,
    useUpdateDriverLicenceMutation,
    useAddDriverLicenceMutation,
    useLinkRecordToProfileMutation,
} = driverLicenceInjectedEndpoints;
